import { all } from 'redux-saga/effects'

import beneficialOwnersSaga from './components/BeneficialOwners/saga'
import endUsersSaga from './components/EndUsersSK/saga'
import representativesSaga from './components/Representatives/saga'

export default function* personsSaga() {
    yield all([endUsersSaga(), representativesSaga(), beneficialOwnersSaga()])
}
